<template>
  <div class="general-data">
    <el-row>
      <el-col class="general-header">
        <h1>Datos generales</h1>
      </el-col>
    </el-row>
    <br><br>
    <el-form
      :model="model"
      :rules="rules">
      <el-row :gutter="20">
        <el-col
          :xs="24"
          :sm="24"
          :md="8"
          :lg="8"
          :xl="8"
          class="col">
          <label>Usuario</label>
          <el-form-item
            prop="userName"
            class="form-item">
            <el-input
              v-model="model.userName"/>
          </el-form-item>
        </el-col>
        <el-col
          :xs="24"
          :sm="24"
          :md="8"
          :lg="8"
          :xl="8"
          class="col">
          <label>Nombre</label>
          <el-form-item
            prop="userName"
            class="form-item">
            <el-input
              v-model="model.userName"/>
          </el-form-item>
        </el-col>
        <el-col
          :xs="24"
          :sm="24"
          :md="8"
          :lg="8"
          :xl="8"
          class="col">
          <label>Apellido</label>
          <el-form-item
            prop="userName"
            class="form-item">
            <el-input
              v-model="model.userName"/>
          </el-form-item>
        </el-col>
        <el-col
          :span="24"
          class="col">
          <label>Mail</label>
          <el-form-item
            prop="userName"
            class="form-item">
            <el-input
              v-model="model.userName"/>
          </el-form-item>
        </el-col>
        <el-col
          :xs="24"
          :sm="24"
          :md="8"
          :lg="8"
          :xl="8"
          class="col">
          <label>Fecha de nacimiento</label>
          <el-form-item
            prop="userName"
            class="form-item"/>
        </el-col>
        <el-col
          :xs="24"
          :sm="24"
          :md="8"
          :lg="8"
          :xl="8"
          class="col">
          <label>Sexo</label>
          <el-form-item
            prop="userName"
            class="form-item">
            <el-select v-model="value1">
              <el-option
                label="Masculino"
                value="masculino"/>
              <el-option
                label="Femenino"
                value="femenino"/>
              <el-option
                label="Indefinido"
                value="indefinido"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col
          :xs="24"
          :sm="24"
          :md="8"
          :lg="8"
          :xl="8"
          class="col">
          <label>Miembro desde</label>
        </el-col>
        <el-col
          :span="24"
          class="btns">
          <el-button>Guardar</el-button>
          <el-button type="text">Cancelar</el-button>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import AuthSignInModel from '@/models/auth-sign-in.model'
export default {
  name: 'EditProfile',
  data () {
    return {
      model: AuthSignInModel.model(),
      rules: AuthSignInModel.rules,
      value1: ''
    }
  }
}
</script>

<style lang="scss" scoped>

  .general-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #E3E6EA;
    padding-bottom: 15px;
    h1 {
      margin: 0;
      @include font-primary(14px, semibold)
    }
    .icons-data {
      color: black;
      cursor: pointer;
      i:not(:first-child) {
        margin-left: 30px;
      }
    }
  }
  .btns{
    margin-top: 10px;
    button{
      &:first-child{
        background-color: $roseHeader;
        white-space: normal;
        @include font-primary(12px, bold);
        color: white;
        border: none;
        width: 95px;
        border-radius: 3px;
      }
      &:nth-child(2){
        white-space: normal;
        @include font-primary(12px, bold);
        color: $roseHeader;
        border: none;
        width: 95px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/user-profile/edit-profile.vue